import { isEmptyString } from '@/utils/string';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook to handle the `ai-message` query parameter.
 * Calls the onLoad callback with the prefilled message when the parameter is present.
 * Automatically clears the query parameter after reading it.
 * Note: The onLoad callback is responsible for opening the sidebar.
 */
export function useAiMessageParam(onLoad?: (value: string) => void) {
  const [searchParams, setSearchParams] = useSearchParams();
  const lastProcessedMessage = useRef<string | null>(null);

  useEffect(() => {
    const aiMessage = searchParams.get('ai-message');

    // Only process if there's a message and it's different from the last one we processed
    if (!isEmptyString(aiMessage) && aiMessage !== lastProcessedMessage.current) {
      lastProcessedMessage.current = aiMessage;

      // Call the onLoad callback with the message
      onLoad?.(aiMessage);

      // Remove the query parameter from the URL
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('ai-message');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams, onLoad]);
}
